import React from 'react';
import {Outlet} from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';

import './CSS/Layout.css';

const PublicLayout: React.FC = () => {
    return (
        <div id='Public-layout'>
            <div className='SW-update-dialog'></div>
            <Header></Header>
            <div className='container'>
                <Outlet />
            </div>
            <Footer></Footer>
        </div>
    );
};

export default PublicLayout;
